import { PaymentType } from '@/models/payment-plan';
import { DurationOption } from '@/core/domain/entities/Product';

export const Environment = {
  currency: 'GHS',
  products: 'inventory',
  partners: 'merchant_shops',
  platform: 'ecommerce',
  merchantCategory: 'product_category',
  inventoryCategory: 'product_category',
  noImage: '/assets/images/no-image.png',
  origin: 'Motito Marketplace',
  verificationCardCollection: 'identification_card',
  terms: 'https://motito.co/terms-and-conditions.html',
  privacy: 'https://motito.co/privacy-policy.html',
  daysInMonth: 30,
  frequency: {
    daily: 1,
    monthly: 30,
    weekly: 7,
  } as Record<'daily' | 'monthly' | 'weekly', number>,
  orders: 'orders',

  baseBillingFrequency: (key: keyof DurationOption) => {
    switch (key) {
      case 'monthly':
        return 'Months';
      case 'weekly':
        return 'Weeks';
      case 'daily':
        return 'Days';
      default:
        return '';
    }
  },
  category: [
    {
      title: 'Phones & Accessories',
      value: 'mobile_phones',
      query: [],
    },
    {
      title: 'Computing',
      value: 'computing',
      query: [],
    },
    {
      title: 'Electronics',
      value: 'electronics',
      query: [],
    },
    {
      title: 'Furniture',
      value: 'furniture',
      query: [],
    },
    {
      title: 'Beauty & Fashion',
      value: 'beauty_fashion',
      query: [],
    },
    {
      title: 'Appliances',
      value: 'electronics',
      query: [],
    },
    {
      title: 'Industrial Machinery',
      value: 'industrial_machinery',
      query: [],
    },
  ],
  marketingProcess: [
    {
      name: 'Through a friend or family',
      value: 'friend-family',
    },
    {
      name: 'Through a merchant',
      value: 'merchant',
    },
    {
      name: 'Instagram',
      value: 'instagram',
    },
    {
      name: 'Facebook',
      value: 'facebook',
    },
    {
      name: 'LinkedIn',
      value: 'linkedin',
    },
    {
      name: 'Twitter',
      value: 'twitter',
    },
    {
      name: 'TikTok',
      value: 'tiktok',
    },
    {
      name: 'Google Playstore',
      value: 'google-playstore',
    },
    {
      name: 'Apple app store',
      value: 'apple-app-store',
    },
    {
      name: 'Others',
      value: 'others',
    },
  ],
  gender: ['Male', 'Female'],
  status: ['Married', 'Single', 'Divorced'],
  identities: [
    {
      assets: '/assets/svgs/Icons/IdentificationCard.svg',
      title: 'Ghana card',
      url: 'ghana_card',
      description: 'Upload a photo or scan of your Ghana card',
      type: 'IDType.NationalID',
    },
    {
      assets: '/assets/svgs/Icons/IdentificationBadge.svg',
      title: 'Passport',
      url: 'passport',
      description: 'Upload a photo or scan of your passport photo page',
      type: 'IDType.NationalID',
    },
    // {
    //   assets: '/assets/svgs/Icons/IdentificationCard.svg',
    //   title: "Driver's License",
    //   url: 'driver_license',
    //   description: "Upload a photo or scan your driver's license",
    // },
    // {
    //   assets: '/assets/svgs/Icons/AddressBook.svg',
    //   title: "Voter's ID",
    //   url: 'voter_id',
    //   description: "Upload a photo or scan of your voter's ID card",
    // },
  ],
  regions: [
    'Ashanti Region',
    'Brong Ahafo Region',
    'Central Region',
    'Eastern Region',
    'Greater Accra Region',
    'Northern Region',
    'Upper East Region',
    'Upper West Region',
    'Volta Region',
    'Western Region',
    'Savannah Region',
    'Bono East Region',
    'Oti Region',
    'Ahafo Region',
    'Western North Region',
    'North East Region',
  ],
  paymentPlanInfo: [
    'All amounts saved are kept in an Ecobank xPress account.',
    'You can also insure price of item against inflations.',
    'Users can pickup item when user saves up tp 60% of the item and qualify to do so',
  ],
  paymentOptions: [
    {
      title: 'Pay Small Small',
      desc: 'Save up to 60% and receive item while you pay the rest.',
      learn: '/help',
      icon: '/assets/svgs/PiggyBank.svg',
      type: PaymentType.PAYSMALL_SMALL,
    },
    // Hidden for now - focusing on Pay Small Small only
    // {
    //   icon: '/assets/svgs/CardHolder.svg',
    //   title: 'Other payment options',
    //   desc: 'Explore our other flexible payment options.',
    //   learn: '/help',
    //   type: PaymentType.FULL_PAYMENT,
    // },
  ],
  subPaymentOptions: [
    {
      provider: 'MTN',
      title: 'MTN PaySmallSmall',
      desc: 'Save up for a purchase with your MTN mobile money wallet',
      value: 'PaymentPartner.MTN_MOMO',
      type: 'mtn_mobile_money',
    },
    {
      provider: 'Telecel',
      title: 'Telecel PaySmallSmall',
      desc: 'Save up for a purchase with your vodafone cash wallet',
      value: 'PaymentPartner.VODAFONE_CASH',
      type: 'telecel_mobile_money',
    },
    {
      provider: 'Motito',
      title: 'Motito PaySmallSmall',
      desc: 'Saveup for a purchase with motito, via Ecobank Xpress account',
      value: 'x',
      type: 'debit_card',
    },
    {
      provider: 'Card',
      title: 'Buy now PayLater (subject to eligibility)',
      desc: 'Buy now, pay-later. Make a 40% deposit and pick your item',
      value: 'PaymentPartner.MTN_MOMO',
      type: PaymentType.INSTALLMENT,
    },
    {
      provider: 'Paystack',
      title: 'Pay now - Cash & Carry',
      desc: 'One time full purchase',
      value: 'PaymentPartner.ECOBANK',
      type: 'debit_card',
    },
  ],
  partnerships: {
    telecel: {
      logo: '/assets/images/partners/telecel.png',
      colorLight: '#FF868636',
      title: 'PaySmallSmall With Telecel.',
      description:
        'Conveniently save for your next big item while keeping the price locked ',
      primaryColor: '#E32527',
      showDownloadApp: false,
      textColor: '#141414',
      host: 'telecel.motito.co',
      // Banner shown on partner domains
      banner: {
        show: true,
        text: 'Motito has partnered with Telecel to provide financing options for Telecel customers.',
      },
      // Slider configuration for homepage
      slider: {
        backgroundColor: '#E32527',
        image: '/assets/images/mtn-slider-image.png', // TODO: Replace with Telecel image
        title: 'PaySmallSmall',
        subtitle: 'Pay for your favourite items @ 0% interest',
        description:
          'Use Telecel Cash PaySmallSmall to save for your dream purchases!',
        showButton: false,
      },
    },
    mtn: {
      logo: '/assets/logos/mtn.png',
      colorLight: '#004F71',
      title: 'PaySmallSmall With MTN MoMo.',
      description:
        'Conveniently save for your next big item while keeping the price locked ',
      primaryColor: '#141414',
      showDownloadApp: false,
      textColor: '#FFFFFF',
      host: 'mtn.motito.co',
      // Banner shown on partner domains
      banner: {
        show: true,
        text: 'Motito has partnered with MTN to provide financing options for MTN customers.',
      },
      // Slider configuration for homepage
      slider: {
        backgroundColor: '#004F71',
        image: '/assets/images/mtn-slider-image.png',
        title: 'PaySmallSmall',
        subtitle: 'Pay for your favourite items @ 0% interest',
        description:
          'Tired of missing out on your dream purchases due to price fluctuations or stock shortages? Use MTN MoMo PaySmallSmall Now!',
        showButton: false,
      },
    },
    ecobank: {
      logo: '/assets/images/partners/ecobank.png',
      colorLight: '#E3DFFF',
      title: 'Buy Now. Pay later. With Ecobank.',
      description:
        'Enjoy unbeatable instalment payment plan as an Ecobank customer',
      primaryColor: '#0046C8',
      showDownloadApp: false,
      textColor: '#141414',
      host: 'ecobank.motito.co',
      // Banner shown on partner domains
      banner: {
        show: true,
        text: 'Motito has partnered with Ecobank to provide financing options for Ecobank customers.',
      },
      // Slider configuration for homepage
      slider: {
        backgroundColor: '#0046C8',
        image: '/assets/images/mtn-slider-image.png', // TODO: Replace with Ecobank image
        title: 'Buy Now. Pay Later.',
        subtitle: 'Enjoy unbeatable instalment payment plans',
        description: 'Finance your next big purchase with Ecobank integration.',
        showButton: false,
      },
    },
    motito: {
      logo: '/assets/svgs/motito.svg',
      colorLight: '#E3DFFF',
      title: 'Buy Now. Pay later. With Motito.',
      description:
        'Enjoy unbeatable instalment payment plan with Motito',
      primaryColor: '#6366F1', // Motito primary purple
      showDownloadApp: true,
      textColor: '#141414',
      host: 'motito.co',
      // No banner for generic Motito marketplace
      banner: {
        show: false,
        text: '',
      },
      // Generic slider for Motito marketplace
      slider: {
        backgroundColor: '#004F71',
        image: '/assets/images/mtn-slider-image.png',
        title: 'A better way to finance your next asset.',
        subtitle: '',
        description: '',
        showButton: true,
      },
    },
  },
  appUrl: 'https://google.com',
  links: {
    tnc: '/signup/tnc',
  },
};
